import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Device, DeviceState, DeviceType } from '@era/locations-sdk';
import { DeviceStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { DeviceGridComponent } from '../device-grid/device-grid.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'era-devices-unavailable',
  templateUrl: './devices-unavailable.container.html',
  styleUrls: ['./devices-unavailable.container.scss'],
  imports: [DeviceGridComponent, AsyncPipe],
})
export class DevicesUnavailableContainerComponent {
  public readonly unavailableDevices$: Observable<Device[]>;
  constructor(
    private readonly deviceStore: Store<Device>,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {
    this.unavailableDevices$ = this.deviceStore.select(
      DeviceStoreSelectors.selectDevicesByState(DeviceState.Unavailable)
    );
  }

  public itemSelected(device: Device) {
    if (device.deviceType === DeviceType.Apple) {
      void this.router.navigate(['apple', device.deviceId], { relativeTo: this.route });
    }
  }
}
